// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".045cc2e2a07bb4a39be32cf6dd7a964d.js";
};